import { axios } from 'services/axios';

const getCompanyNavigationList = async (wholesalerId) => {
    const res = await axios.get(`/CompanyNavigationList/${wholesalerId}`);
    return res.data;
};

export default getCompanyNavigationList;
